var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoveToPostIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18.5,
    r: 18,
    transform: "rotate(-180 18 18.5)",
    fill: "#672C78"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 9.5H12c-1.657 0-3 1.34-3 2.997v12.005a2.998 2.998 0 0 0 3 2.998h12a3 3 0 0 0 3-3v-12a3 3 0 0 0-3-3z",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 14.165c0 2.438-3 4.335-3 4.335s-3-1.898-3-4.335c0-.922.75-1.665 1.665-1.665.547 0 1.027.262 1.335.66a1.68 1.68 0 0 1 1.328-.66c.922 0 1.665.742 1.665 1.665H24z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 21.5h6.75M12 24.5h10.5",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoveToPostIcon);
export default __webpack_public_path__ + "static/media/move_to_post_icon.632ba264206008c223330b6180be7796.svg";
export { ForwardRef as ReactComponent };